import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { VaButtonComponent } from '../wrappers/va-button/va-button.component';
import { VaCheckboxComponent } from '../wrappers/va-checkbox/va-checkbox.component';
import { VaChipComponent } from '../wrappers/va-chip/va-chip.component';
import { VaExpandDirective } from '../wrappers/va-expand/va-expand.directive';
import { VaMenuComponent } from '../wrappers/va-menu/va-menu.component';
import { VaMultilineComponent } from '../wrappers/va-multiline/va-multiline.component';
import { VaSwitchComponent } from '../wrappers/va-switch/va-switch.component';

import { TranslateModule } from '@ngx-translate/core';
import { CellDirective } from './cells/cell.directive';
import { ColumnSelectorComponent } from './column-selector.component';
import { TableComponent } from './table.component';
import {
  AsObjectCellPipe,
  AsTextCellPipe,
  GetMaxWidthPipe,
  GetMinWidthPipe,
  GetSortingIndicatorClassPipe,
  IsSortedPropertyPipe,
  RowStatusCssPipe,
  TextDirectionPipe,
} from './table.pipe';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatListModule,
    MatCardModule,
    VaButtonComponent,
    VaCheckboxComponent,
    VaExpandDirective,
    VaMultilineComponent,
    VaSwitchComponent,
    VaMenuComponent,
    VaChipComponent,
    TranslateModule,
  ],
  declarations: [
    TableComponent,
    ColumnSelectorComponent,
    CellDirective,
    GetSortingIndicatorClassPipe,
    AsTextCellPipe,
    AsObjectCellPipe,
    GetMinWidthPipe,
    GetMaxWidthPipe,
    RowStatusCssPipe,
    TextDirectionPipe,
    IsSortedPropertyPipe,
  ],
  exports: [TableComponent, ColumnSelectorComponent],
})
export class VaTableModule {}
